import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';

import ContentHeader from 'components/ContentHeader';
import DiplomaButton from 'components/DiplomaButton/DiplomaButton';
import TrainingGrid from 'components/TrainingGrid';

import APIHandler from 'config/APIHandler';

import { useChapters } from 'hooks/useChapters';
import { useSettings } from 'hooks/useSettings';
import { useUserInfo } from 'hooks/useUserInfo';

const TrainingView = ({ history = null }) => {
  const { appId } = useSettings();
  const {
    user: { first_name: firstName, last_name: lastName, email },
  } = useUserInfo();
  const { diplomaRate } = useChapters();

  useEffect(() => {
    const updateUserIfNeeded = async () => {
      if (diplomaRate >= 100) {
        const d = new Date(Date.now());
        const leading = (val) => `0${val}`.slice(-2);
        const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;
        await APIHandler.updateUser(appId, email, [
          { param: 'training_started', val: date },
          { param: 'sales_companion_registered', val: date },
          { param: 'training_graduated', val: date },
        ]);
      }
    };

    updateUserIfNeeded(); // Call the async function within the effect
  }, [diplomaRate, appId, email]);

  return (
    <div className="contentContainer trainingView">
      <ContentHeader header={i18n.translate('nav.train')} subtitle={i18n.translate('pageDescriptions.train')} hr>
        <DiplomaButton
          className="trainingView__diploma-button"
          appId={appId}
          firstName={firstName}
          lastName={lastName}
          email={email}
          diplomaRate={diplomaRate}
        />
      </ContentHeader>
      <TrainingGrid history={history} />
    </div>
  );
};
TrainingView.propTypes = {
  history: PropTypes.shape(),
};

export default TrainingView;
